// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"652":"186e3c84","829":"4c809f09"}[chunkId] + ".js";
};